<div
  *ngIf="app.hasError"
  class="top-bar error-notification"
  style="cursor: pointer"
  [ngClass]="{'error-notification-modal': app.hasError}"
>
  <div class="container">
    <div class="p-1">
      <div class="col-md-2 pull-left">
        <i class="fa-solid fa-ban banIcon"></i>
      </div>
      <div class="col-md-10 pull-right">
        {{ app.text.app.error }}
        <div class="close-btn pull-right" (click)="app.hasError = false">
          <i class="fa fa-times"></i>
        </div>
      </div>
      <div class="col-md-12">
        {{ app.errorText }}
      </div>
    </div>
  </div>
</div>
<ng-template
  #content
  let-modal
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <div class="row">
    <div class="m-1 p-1">
      <div class="m-2 p-2 text-center">
        <i class="fa-regular fa-lock lockIcon"></i>
      </div>
      <div class="m-2 p-2">
        <div class="authText text-center">{{ app.text.auth.twoFactorAuth }}</div>
      </div>
      <div class="m-2 p-2">
        <div class="two-factor-text text-center">
          {{ app.text.auth.twoFactorText }}
        </div>
      </div>
    </div>
    <div class="row inputRow">
      <div class="m-1 col-md-6">
        <div class="countdown">
          <h3>{{ countdownTime }}</h3>
        </div>
        <div class="m-2 p-2 two-factor-code">
          <div class="otp-container">
            <input
              *ngFor="let digit of otpArray; let i = index"
              [attr.id]="'otp-' + i"
              [(ngModel)]="otpCode[i]"
              maxlength="1"
              (keydown)="onKeyDown($event, i)"
              (input)="onInput($event, i)"
              (paste)="onPaste($event)"
              type="text"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="controls text-center my-4">
          <button class="btn sendEmailBtn" (click)="submitCode()">
            {{ app.text.auth.submitCode }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- <div class="app-footer">
    <app-footer></app-footer>
</div> -->
